import { Injectable } from '@angular/core';
import { HttpClient, HttpParams,HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestData } from 'src/app/common/models/request-data.model';
import { environment } from 'src/environments/environment';
import { staffAttendanceModel } from './staff-attendance/model/staffAttendanceModel.model';


@Injectable({
  providedIn: 'root'
})
export class StaffAttendanceService {

  constructor(private http: HttpClient) { }

   getList(requestData:RequestData): Observable<any> {
       return this.http.post(environment.baseUrl+'/shop/staff-attendance/get', requestData);

     }

     downloadExcel(requestData: any): Observable<Blob> {
                     const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
                    // const url = 'http://yourdomain.com/api/customers/export'; // Adjust URL
                 
                     return this.http.post(environment.baseUrl + '/shop/staff-attendance/export', requestData, { headers, responseType: 'blob' })
                       .pipe(
                         //catchError(this.handleError)
                       );
                 
                   }

                    getById(id:number): Observable<any> {
      return this.http.post(environment.baseUrl+'/shop/staff-attendance/get/'+id, '');
  
    }


     update(staffAttendanceinfo: staffAttendanceModel): Observable<any> { 
          if(staffAttendanceinfo.hasOwnProperty("id")){
            return this.http.post(environment.baseUrl+'/shop/staff-attendance/update', staffAttendanceinfo);
          } else{
            return this.http.post(environment.baseUrl+'/shop/staff-attendance/add', staffAttendanceinfo);
          }
        }

        delete(staffAttendanceInfo: staffAttendanceModel): Observable<any>  {
                return this.http.post(environment.baseUrl+'/shop/staff-attendance/delete/'+staffAttendanceInfo.id, staffAttendanceInfo);
              }

              finalize(staffAttendanceInfo: staffAttendanceModel): Observable<any>  {
                return this.http.post(environment.baseUrl+'/shop/staff-attendance/finalize/'+staffAttendanceInfo.id, staffAttendanceInfo);
              }

              getWeekNoList(requestData:RequestData): Observable<any> {
                return this.http.post(environment.baseUrl+'/week-def/get', requestData);
            
              }
          
                   
}
